/**
 * airan-ntn — Beam Hop xApp
 * Schedules beam hopping based on UE distribution and interference
 */

import { XAppBase } from './XAppBase.js';
import { E2KpmReport, E2RcAction, XAppDecision } from '../types.js';

export class BeamHopXApp extends XAppBase {
  private beamLoads: Map<number, number[]> = new Map();

  constructor(enabled: boolean = true) {
    super('beam-hop', enabled);
  }

  processKpmReport(report: E2KpmReport): void {
    const loads = report.sliceMetrics.map(s => s.prbUsed / Math.max(1, s.prbAllocated));
    this.beamLoads.set(report.gnbId, loads);
  }

  decisionCycle(): XAppDecision {
    const start = performance.now();
    const actions: E2RcAction[] = [];

    for (const [gnbId, loads] of this.beamLoads) {
      const maxLoad = Math.max(...loads);
      const minLoad = Math.min(...loads);
      if (maxLoad - minLoad > 0.3) {
        actions.push({
          type: 'BEAM_HOP_SCHEDULE',
          targetId: gnbId,
          payload: { pattern: 'load_balancing', beams: loads.length },
          priority: this.config.priority,
          timestamp: Date.now()
        });
      }
    }

    const latency = performance.now() - start;
    this.recordDecision(latency);

    return { actions, confidence: 0.8, latencyMs: latency };
  }

  getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string } {
    return {
      eventTriggers: this.config.requiredEventTriggers,
      reportStyle: this.config.requiredReportStyle
    };
  }
}